export class QuickBooksConnectionStatus {
    connectedProduct: 'QBD' | 'QBO';
    connected: boolean;
    isActive: boolean;
    isSetupCompleted: boolean;
  }